import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export default function CustomBreadcrumbs({linksArray, title}) {
  const breadcrumbs = [
    <Link
      key="1"
      href="/"
      underline="hover"
      color="inherit"
      sx={{ display: 'flex', alignItems: 'center' }}
    >
      <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
    </Link>,
  ];

 linksArray.forEach((link, index) => {
    breadcrumbs.push(
      <Link
        key={`link-${index}`}
        underline="hover"
        color="inherit"
        href={link.href}
      >
        {link.label}
      </Link>
    );
  });

  breadcrumbs.push(
    <Typography key="4" color="text.primary">
      {title}
    </Typography>
  );


  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {breadcrumbs}
    </Breadcrumbs>
  );
}
